import * as moment from 'moment';
import { timeout } from 'rxjs/operators';

export class InboundPatientRecord {
  private Name: {
    FamilyName: string,
    GivenName: string
  };
  private PatientId: string;
  private PrimaryLanguage: string;
  private MaritalStatus: string;
  private Gender: string;
  private BirthDate: string; // YYYY-MM-DD
  private ChiefComplaint: string;
  private Destination: string;
  private ETA: string;
  private BloodPressure: string;
  private HeartRate: string;
  private RespiratoryRate: string;
  private RadioNumber: string;
  private AlertReceivedDateTime: string; // JSON DateTime string
  private AlertProcessedDateTime: string; // JSON DateTime string

  dateTime: string;
  sex: string;
  age: number;
  chiefComplaint: string;
  eta: number;
  bloodPressure: string;
  heartRate: string;
  respiratoryRate: string;
  destinationFacility: string;
  medicUnit: string;
  alertAcknowledged: boolean;
  alertAcknowledgedDateTime: string;

  dateTimeUnix: number;

  acknowledgeStatus: number = 0; // 0 - nothing, 1 - in progress, 2 - success, 4 - failed.
  searchString: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.sex = this.Gender ? this.Gender[0] : '';
    this.chiefComplaint = this.ChiefComplaint || '';
    this.destinationFacility = this.Destination || '';
    this.bloodPressure = this.BloodPressure || '';
    this.heartRate = this.HeartRate || '';
    this.respiratoryRate = this.RespiratoryRate || '';
    this.medicUnit = this.RadioNumber || '';
    this.eta = this.ETA && (
        this.ETA.match(/(-|:)/gi) &&
        moment(this.ETA).isValid()
    ) ? moment(this.ETA).diff(moment(), 'minutes', false) : +this.ETA;
    this.dateTime = moment(this.AlertReceivedDateTime).format('MM/DD HH:mm');
    this.dateTimeUnix = moment(this.AlertReceivedDateTime).unix();
    if (this.BirthDate) {
      this.age = +`${moment().diff(this.BirthDate, 'years', false) || -1}`;
    }
    this.alertAcknowledged = !!this.AlertProcessedDateTime;
    this.setAlertAcknowledgeDateTime();
    this.searchString = [
      this.Gender,
      this.chiefComplaint,
      this.bloodPressure,
      this.heartRate,
      this.respiratoryRate,
      this.destinationFacility,
      this.medicUnit,
      `eta:${this.eta}`,
      `rec:${this.dateTime}`,
      `age:${this.age}`,
      `ack:${this.alertAcknowledged ? 'y' : 'n'}`,
      `sex:${this.sex}`
    ].join('|');
  }

  get patientId(): string {
    return this.PatientId;
  }

  private setAlertAcknowledgeDateTime() {
    this.alertAcknowledgedDateTime = this.AlertProcessedDateTime ?
      `Acknowledged ${moment(this.AlertProcessedDateTime).format('MM/DD HH:mm')}`
      : 'Alert has not yet been acknowledged.';
  }

  acknowledge(): any {
    if (this.acknowledgeStatus > 0) {
      return false;
    }
    this.acknowledgeStatus = 1;
    return {
      success: (success) => {
        if (!success) {
          this.acknowledgeStatus = 4;
          setTimeout(() => this.acknowledgeStatus = 0, 3000);
          return;
        }
        this.AlertProcessedDateTime = new Date().toJSON();
        this.alertAcknowledged = !!this.AlertProcessedDateTime;
        this.setAlertAcknowledgeDateTime();
        this.acknowledgeStatus = 2;
        setTimeout(() => this.acknowledgeStatus = 0, 3000);
    },
      error: (success) => {
        this.acknowledgeStatus = 4;
        setTimeout(() => this.acknowledgeStatus = 0, 3000);
      }
    };
  }
}